import { IProductGroup } from "opp-api-lib-js";
import React from "react";
import { Link } from "react-router-dom";
import EmbedWordpress from "../components/EmbedWordpress";
import Thumbnail from "../components/Thumbnail";

interface IProps {
    productGroups: IProductGroup[];
}

export default class ProductGroupsPage extends React.Component<IProps> {
    public render(): JSX.Element {
        const { productGroups } = this.props;
        return (
            <div className="content-wrapper">
                <EmbedWordpress slug="above-productgroups" />
                <div className="columns is-multiline">
                    { productGroups.map((productGroup: IProductGroup): JSX.Element => {
                        return (
                            <div
                                className="column is-4"
                                key={ productGroup.id }
                            >
                                <Link
                                    to={ `/${ productGroup.abbrev }/` }
                                >
                                    <Thumbnail entity={ productGroup } />
                                </Link>
                            </div>
                        );
                    }) }
                </div>
                <EmbedWordpress slug="below-productgroups" />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/ProductGroupsPage.tsx